import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  routes: [
    {
      path: "/admin",
      redirect: "/admin/host",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Host",
          path: "hosts",
          component: () => import("@/views/logistic/Host"),
        },
        {
          name: "Subscription",
          path: "subscriptions",
          component: () => import("@/views/logistic/Subscription"),
        },
        {
          name: "Users",
          path: "users",
          component: () => import("@/views/logistic/Users"),
        },
        {
          name: "Devices",
          path: "devices",
          component: () => import("@/views/logistic/Device"),
        },
        {
          name: "Userproject",
          path: "userproject",
          component: () => import("@/views/logistic/UserProject"),
        },
      ],
    },
    {
      path: "/profile",
      redirect: "/profile/account",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Profile",
          path: "account",
          component: () => import("@/views/profile/Account"),
        },
      ],
    },
    {
      path: "/",
      redirect: "/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "BoxedLogin",
          path: "login",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
      ],
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
